export default "__VITE_ASSET__CKYa53CG__"